import { Component, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { AgGridI } from '../../../../../../shared/components/ag-grid/ag-grid.model';
import { AgGridComponent } from '../../../../../../shared/components/ag-grid/ag-grid.component';
import { AgGridDataModelConfirmSelection } from '../../../part-list.model';
import { PaginationModel } from '../../../../../../shared/model/pagination.model';
import { VendorPartsLibraryService } from '../../../../vendor-parts-library/pages/vendor-parts-library/vendor-parts-library.service';
import { AgGridService } from '../../../../../../shared/components/ag-grid/ag-grid.service';
import { StorageService } from '../../../../../../shared/services/storage.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-confirm-selection-tab',
  templateUrl: './confirm-selection-tab.component.html',
  styleUrls: ['./confirm-selection-tab.component.scss']
})
export class ConfirmSelectionTabComponent implements OnInit {
  AgGridDataModel: AgGridI;
  gridApiForDataModel: any
  @ViewChildren(AgGridComponent) grids: QueryList<AgGridComponent>
  @Input()  data:any ={}
  paginationModel : any = {};
   constructor(public vplService: VendorPartsLibraryService,public agGridService: AgGridService,
    public storageService:StorageService,
    public toaster: ToastrService,
   ) { 
  }

  ngOnInit(): void {
    this.AgGridDataModel = AgGridDataModelConfirmSelection;
  }

  onPagination(pagination: PaginationModel) {
    this.paginationModel.pageNumber = pagination?.pageNumber;
    this.paginationModel.pageSize = pagination?.pageSize;
    this.paginationModel.getAll = pagination?.getAll;
    this.paginate();
  }
    getRowStyle = (params: any) => {
      return { borderBottom: '1px solid #E9EDF2' };
    };
    
    onSelectionChange(params) {
       let data = params?.api?.getSelectedRows();
       this.data.confirmedData = [...data]
    }
    onGridReady(event) {
      this.gridApiForDataModel  = event;
  }
  triggerGridReady() {
   this.paginate() 
    this.gridApiForDataModel?.api?.forEachNode(node => {
      if (node.data?.id) {
        node.setSelected(true);
      }
    });
  this.agGridService.toggleHeaderCheckedValue.next({params:null,value:true});
  }
 paginate() {
     let  gridRef = this.grids?.first;
    const startIndex = (this.paginationModel?.pageNumber - 1) * this.paginationModel?.pageSize;
    const endIndex = startIndex + this.paginationModel?.pageSize;
    this.data.paginatedItems = this.data?.selectedRowData?.slice(startIndex, endIndex);
    this.gridApiForDataModel?.api?.setRowData(this.paginationModel.getAll?this.data?.selectedRowData:this.data?.paginatedItems??[]);
    gridRef.updatePaginationData(this.paginationModel, this.data?.selectedRowData?.length??0);
  }
onSelectOptionClick(event: any): void {
  let dropDown =   this.storageService.retrieve('PART_DROPDOWNLIST')
  let dropdownValues: any[]  = dropDown?.requestVendorContactList??[];

  if (!event?.node?.selected) {
    const data = dropdownValues?.find(x => x.extra1 == event?.data?.vendorContactEmail);
   const updatedData = { ...event.node.data, vendorContactId: data?.id };
  event.node.setData(updatedData); 
  this.toaster.error('Please select row.');
  return;
}
  if (
    event?.rowIndex != null &&
    this.data?.confirmedData &&
    this.data.confirmedData[event.rowIndex]
  ) {
    const row = this.data.confirmedData[event.rowIndex];
    Object.assign(row, event.data);
    if (!event?.value) {
      row.vendorContact = "";
      row.vendorContactEmail = "";
    } else {
      const data = dropdownValues?.find(x => x.id == event?.value);
      if (data) {
       row.vendorContact = data.name;
       row.vendorContactEmail = data.extra1;
      }
     }
    if (event?.api && event?.node) {
      event.api.refreshCells({ rowNodes: [event.node], force: true });
    }
  } else {
    console.warn('Invalid event or confirmedData missing at index');
  }
}

}